import { render, staticRenderFns } from "./QuestionLongAnswer.vue?vue&type=template&id=5c10479e&scoped=true"
import script from "./QuestionLongAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionLongAnswer.vue?vue&type=script&lang=js"
import style0 from "./QuestionLongAnswer.vue?vue&type=style&index=0&id=5c10479e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10479e",
  null
  
)

export default component.exports